import { Component } from '@angular/core';

@Component({
  selector: 'app-ambassador',
  templateUrl: './ambassador.component.html',
  styleUrls: ['./ambassador.component.css']
})
export class AmbassadorComponent {
  readonly applyUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSd03sbkVTPV-7bTGfYuM5Mm6QS9sn8h8spxuPmXAgcapXvWhw/viewform?usp=header';
  readonly whatsappUrl = 'https://chat.whatsapp.com/DKW8NmfvpeXFGv6y1niTtk?mode=gi_t';
  readonly year = new Date().getFullYear();

  painPoints = [
    { icon: 'home', title: 'No safe housing intel', description: 'Incoming corpers spend weeks scrambling for decent accommodation nobody told them about.' },
    { icon: 'domain', title: 'Unknown PPAs', description: 'Arriving at your PPA with zero idea what to expect - wasted time, wasted hope.' },
    { icon: 'savings', title: 'Wasted spending', description: 'Buying new mattresses, fans, and cookers that another corper would have sold for half the price.' },
    { icon: 'forum', title: 'No community', description: 'No verified space to ask real questions, get real answers, and connect with fellow corpers.' },
  ]

  roles = [
    {
      num: '01',
      title: 'Create awareness',
      description: 'Spread the word physically on camp and online. Share in WhatsApp groups, post on socials, and tell corpers about corpers.ng wherever you are.',
      badge: null,
    },
    {
      num: '02',
      title: 'Drive sign-ups & listings',
      description: 'Get fellow corpers to sign up, list their items for sale, post their businesses, and add their accommodation details to the platform.',
      badge: null,
    },
    {
      num: '03',
      title: 'Collect PPA reviews',
      description: 'This is the most impactful thing you\'ll do. Encourage every corper you meet to list and honestly review their PPA.',
      badge: 'Highest priority',
    },
  ]

  benefits = [
    { icon: 'payments', title: 'Cash rewards', description: 'Earn bonuses every week you hit your targets.' },
    { icon: 'workspace_premium', title: 'Certificate of service', description: 'A real credential that stands out on your CV.' },
    { icon: 'thumb_up', title: 'LinkedIn endorsement', description: 'Official endorsement from corpers.ng after service.' },
    { icon: 'description', title: 'Recommendation letter', description: 'A strong reference for your next job application.' },
    { icon: 'laptop_mac', title: 'Tech trainings', description: 'Access curated tech courses and hands-on training to build in-demand digital skills during your service year.' },
    { icon: 'handshake', title: 'Internship matching', description: 'Get matched with partner organisations for internships that give you real-world experience and open doors.' },
    { icon: 'work', title: 'Jobs & gigs guidance', description: 'Receive personalised guidance on landing freelance gigs, remote roles, and full-time jobs after NYSC.' },
    { icon: 'trending_up', title: 'Real marketing experience', description: 'Gain product growth skills and hands-on campaign experience you can\'t get in any classroom.' },
    { icon: 'star', title: 'Possible retention', description: 'Top ambassadors may be retained with the company post-NYSC.' },
  ]

  points = [
    { pts: '1 pt', label: 'Sign-up driven' },
    { pts: '3 pts', label: 'Item or business listed' },
    { pts: '5 pts', label: 'PPA review collected' },
    { pts: '5 pts', label: 'Content posted' },
  ]

  readonly weeklyTargetPoints = 50;
}
